import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../content/login/login.service';
import { User } from '../../core/modelos/user';
import { ClientesService } from '../content/clientes/clientes.service';
import { Cliente } from '../../core/modelos/cliente';
import { ClientesComponent } from '../content/clientes/clientes.component';
import { NotificacionesService } from '../../core/notificaciones/notificaciones.service';
import { FileManagerService } from '../content/file-manager/file-manager.service';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';
import { ToolbarService } from './toolbar.service';
import { ActivosService } from '../content/activos/activos.service';
import { Platform } from '@angular/cdk/platform';

@Component({
    selector: 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})

export class FuseToolbarComponent {
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;

    usuario: User;
    esAdmin = false;
    clientes: Array<Cliente>;
    clienteSeleccionado: Cliente;

    contactDialogRef: MatDialogRef<ContactDialogComponent>;

    foto = 'assets/images/logos/bimux.png';
    showNavigation: boolean = false;

    idActivo: number;
    pantalla: string;

    constructor(
        private router: Router,
        private fuseConfig: FuseConfigService,
        private translate: TranslateService,
        private loginService: LoginService,
        private clientesService: ClientesService,
        private notificaciones: NotificacionesService,
        private fileManager: FileManagerService,
        private dialog: MatDialog,
        private toolbarService: ToolbarService,
        private activosService: ActivosService,
        private platform: Platform
    ) {
        if (JSON.parse(sessionStorage.getItem('usuarioLogueado'))) {
            this.usuario = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
            if (this.usuario.rol.id === 1) {
                this.esAdmin = true;
            }
        }

        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                'id': 'es',
                'title': 'Español',
                'flag': 'es'
            },
            {
                'id': 'en',
                'title': 'English',
                'flag': 'us'
            }
        ];

        this.selectedLanguage = this.languages[0];

        router.events.subscribe(
            (event) => {
                if (event instanceof NavigationStart) {
                    this.showLoadingBar = true;
                }
                if (event instanceof NavigationEnd) {
                    this.showLoadingBar = false;

                    if (this.showNavigation) {
                        this.showNavigation = false
                    }

                    const { url } = event
                    this.pantalla = url.includes('dashboard') 
                        ? 'dashboard' 
                        : url.includes('3d-viewer') 
                        ? '3d-viewer'
                        : url.includes('docs') 
                        ? 'file-manager'
                        : url.includes('tickets') 
                        ? 'tickets'
                        : url.includes('power-bi') 
                        ? 'power-bi'
                        : 'portfolio'
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

        if (this.esAdmin) {
            this.getClientes();
        }

        // Listen activos
        this.activosService.currentActivo.subscribe(id => {
            // in order to display the proper fuse-selector (only mobile)
            if (this.platform.ANDROID || this.platform.IOS) {
                this.idActivo = id;
            }
        })
    }

    search(value) {
        // Do your search here...
        // console.log(value);
    }

    setLanguage(lang) {
        // Set the selected language for toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this.translate.use(lang.id);
    }
    logout() {
        this.loginService.logout();
    }

    getClientes() {
        this.clientesService.getClientes().subscribe(
            data => {
                if (data.success) {
                    this.clientes = data.items;

                    if (this.usuario.cliente) {
                        this.clienteSeleccionado = this.usuario.cliente;
                    } else {
                        this.getClienteAdmin();
                    }



                } else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    getClienteAdmin() {
        this.toolbarService.getClienteAdmin().subscribe(
            data => this.clienteSeleccionado = data
        );
    }

    setCliente(cliente: Cliente) {

        // this.clienteSeleccionado = cliente;
        this.toolbarService.setClienteAdmin(cliente);
        ClientesComponent.cambiarCliente(cliente);
        this.fileManager.setClienteBucket(cliente);
        this.router.navigate(['/portfolio']);

    }

    setClienteAdmin(cliente: Cliente) {
        this.clientesService.adminCambiarCliente(cliente.id).subscribe(
            data => {
                if (data.success) {
                    this.setCliente(cliente);
                    sessionStorage.setItem('usuarioLogueado', JSON.stringify({ 'usuario': data  .items }));
                }
                else {
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes);
                }
            },
            err => {
                this.notificaciones.errorServidor(err.status);
            }
        );

    }

    compare(val1, val2) {
        if (val1 && val2) {
            return val1.id === val2.id;
        }
    }

    openContactForm() {

        this.contactDialogRef = this.dialog.open(ContactDialogComponent, {
            width: '400px',
            data: {
                id: '',
                descripcion: '',
                valor: '',
                clave: 1,
                activo_id: ''
            }
        });

    }

    goHome() {
        this.router.navigate(['/portfolio']);
    }

    toggleMobileNavigation() {
        this.showNavigation = !this.showNavigation
    }
}



// WEBPACK FOOTER //
// ./src/app/main/toolbar/toolbar.component.ts